/*
 * @Author: Nora Galvin
 * @Date: 2020-08-17 10:49:48
 * @Last Modified by: Hung Dinh
 * @Last Modified time: 2020-11-25 17:46:51
 */
import template from '@/app/editor/sidebar/templates/gfElement/submitButton.html';

export const submitButtonSettings = [
  {
    name: 'editText',
    caption: 'Text',
    type: 'text',
    class: 'editText',
    target: '.gf_button',
    ref: 'html|html',
  },
  {
    caption: 'Typography',
    type: 'group',
    mode: 'responsive-mode',
    items: [
      {
        name: 'fontWeight',
        id: 'fontWeight',
        caption: 'Font Weight',
        type: 'select',
        options: {
          '100': 'Thin 100',
          '200': 'Semi Thin 200',
          '300': 'Light 300',
          '400': 'Regular 400',
          '500': 'Medium 500',
          '600': 'Semi Bold 600',
          bold: 'Bold 700',
          '800': 'Super Bold 800',
          '900': 'Boldest 900',
          lighter: 'Lighter',
          bolder: 'Bolder',
        },
        default_value: '400',
        mode: 'responsive-mode',
        ref: 'css|font-weight',
        target: '.gf_button',
      },
      {
        name: 'font-size',
        id: 'font-size',
        class: 'gf_to-range',
        caption: 'Font Size',
        type: 'input',
        min: '0',
        max: '100',
        step: '1',
        unit: 'px',
        default_value: '20px',
        mode: 'responsive-mode',
        target: '.gf_button',
        ref: 'css|font-size',
      },
      {
        name: 'font',
        id: 'font',
        class: 'gf_font',
        caption: 'Font',
        type: 'text',
        default_value: '',
        mode: 'responsive-mode',
        target: '.gf_button',
        ref: 'css|font-family',
      },
    ],
  },
  {
    caption: 'Button Color',
    type: 'group',
    mode: 'responsive-mode',
    items: [
      {
        name: 'button-color',
        id: 'button-color',
        class: 'gryff-color',
        caption: 'Background Color',
        type: 'text',
        default_value: '',
        mode: 'responsive-mode',
        target: '.gf_button',
        ref: 'css|background-color',
      },
      {
        name: 'text-color',
        id: 'text-color',
        class: 'gryff-color',
        caption: 'Text Color',
        type: 'text',
        default_value: '',
        mode: 'responsive-mode',
        target: '.gf_button',
        ref: 'css|color',
      },
      {
        name: 'buttonHover',
        id: 'buttonHover',
        class: 'gf_to-switch',
        type: 'text',
        default_value: '0',
        caption: 'Hover Options',
      },
      {
        name: 'button-color-hover',
        id: 'button-color-hover',
        class: 'gryff-color',
        caption: 'Background Color Hover',
        type: 'text',
        default_value: '',
        requires: 'buttonHover|1',
        mode: 'responsive-mode',
        target: '.gf_button:hover',
        ref: 'css|background-color',
      },
      {
        name: 'text-color-hover',
        id: 'text-color-hover',
        class: 'gryff-color',
        caption: 'Text Color Hover',
        type: 'text',
        default_value: '',
        requires: 'buttonHover|1',
        mode: 'responsive-mode',
        target: '.gf_button:hover',
        ref: 'css|color',
      },
    ],
  },
  {
    caption: 'Dimension',
    type: 'group',
    mode: 'responsive-mode',
    items: [
      {
        name: 'stretch',
        id: 'stretch',
        class: 'gf_to-switch',
        type: 'text',
        default_value: '0',
        caption: 'Stretch Button',
        target: '.gf_button',
        ref: 'class|stretch',
      },
      {
        name: 'width',
        caption: 'Width',
        type: 'text',
        unit: '%',
        class: 'width spinner',
        value: '',
        mode: 'responsive-mode',
        target: '.gf_button',
        ref: 'css|width',
      },
      {
        name: 'height',
        caption: 'Height',
        type: 'text',
        unit: 'px',
        class: 'height spinner',
        mode: 'responsive-mode',
        target: '.gf_button',
        ref: 'css|height',
      },
    ],
  },
  {
    id: 'alignment',
    name: 'alignment',
    class: 'gf_to-align',
    caption: 'Alignment',
    type: 'select',
    options: {
      left: 'Left',
      center: 'Center',
      right: 'Right',
    },
    mode: 'responsive-mode',
    target: '.elm',
    ref: 'class|align',
  },
  {
    name: 'extra_class',
    caption: 'Extra Class',
    type: 'text',
    desc: 'If you wish to style particular content element differently, then use this field to add a class name and then refer to it in your css file.',
    target: '.gf_button',
    ref: 'class|classname',
  },
];

export default {
  name: 'Submit Button',
  slug: 'submit-button',
  class: 'gf_button',
  id: 'md-submit',
  html: template(),
  settings: submitButtonSettings,
};
